<template>
  <div
    :ref="'card'"
    class="cursor-pointer tf-carousel-card position-relative bg-white p-4 mx-1"
    :class="screenType === 'mobile' && 'my-3'"
    @click.stop="state.popupOpen = true"
  >
    <div
      ref="card-inner-wrapper"
      class="card-inner-wrapper overflow-hidden position-relative"
    >
      <div class="d-flex body-strong text-grey-900 justify-content-between">
        <div>
          <span v-if="review.authorName">{{ review.authorName }}.</span>
          <span>{{ " " }}</span>
          <span v-if="review.authorSurname">{{ review.authorSurname }}</span>
        </div>
        <div class="d-flex flex-row align-items-center justify-content-center">
          <span class="me-1">{{ this.fomattedRatingByLocale }}/5</span>
          <span>
            <svg class="icon text-primary-blue" width="16" height="16">
              <use href="#___icon___star-full"></use>
            </svg>
          </span>
        </div>
      </div>
      <div class="mb-3 body text-grey-600">
        <span>{{ getCreatedDatePretty(review.creationDate) }}</span>
      </div>
      <div>
        <div class="body text-grey-900">
          <p>{{ review.customerComment }}</p>
        </div>
      </div>
      <!-- <div class="excess-text-cover position-absolute"></div> -->
    </div>
    <div class="show-more-btn position-absolute">
      <span class="cursor-pointer link-small ps-1">{{
        content.reviews_seeMore_popup
      }}</span>
    </div>

    <PopupBase
      :open="state.popupOpen"
      :overlayMaxOpacity="0.8"
      @closePopup="state.popupOpen = false"
    >
      <ReviewPopup
        :open="state.popupOpen"
        :review="review"
        :ratings="ratings"
        @closePopup="state.popupOpen = false"
      />
    </PopupBase>
  </div>
</template>

<script>
import PopupBase from "@/vue/common/popupBase.vue";
import ReviewPopup from "@/vue/reviews/components/popups/reviewPopup.vue";
import { mapState } from "vuex";
import ratingOrder from "@/config/ratingOrder";
import { companyLangToLocale } from "@/config/localeConfig";

export default {
  name: "Review",
  props: {
    review: {
      type: Object,
      default: () => {
        return {};
      },
    },
    cardWidth: String,
  },
  components: {
    PopupBase,
    ReviewPopup,
  },
  data() {
    return {
      state: {
        loading: false,
        animating: false,
        popupOpen: false,
        overflowing: false,
      },
    };
  },

  computed: {
    ...mapState([
      "ssrReviewData",
      "responseReviewData",
      "content",
      "screenType",
      "language",
    ]),

    ratings() {
      return ratingOrder
        .map((ratingName) => {
          const commentRatingName = ratingName.replace("Average", "");
          return {
            name: ratingName,
            rating: this.review[commentRatingName],
          };
        })
        .filter((_) => _);
    },

    fomattedRatingByLocale() {
      try {
        const formattedReview = this.review.avgLihe
          .toFixed(1)
          .replace(/\.0$/, "");

        if (this.language === "fr-FR" || this.language === "fr-FR-CSE") {
          return formattedReview.replace(".", ",");
        } else {
          return formattedReview;
        }
      } catch (error) {
        console.error("Error formatting rating:", error);
        return "0";
      }
    },
  },

  methods: {
    getCreatedDatePretty(dateStr) {
      const dateObj = new Date(dateStr);
      const options = { year: "numeric", month: "long", day: "numeric" };

      let locale = this.language;

      if (this.language === "fr-FR-CSE") {
        const match = document.cookie.match(
          "(^|;)\\s*companyLang\\s*=\\s*([^;]+)"
        );
        if (match && match[2]) {
          const shortLang = decodeURIComponent(match[2]).trim();
          const mappedLocale = companyLangToLocale.get(shortLang);
          locale = mappedLocale || "en-US";
        } else {
          locale = "en-US";
        }
      }

      try {
        return dateObj.toLocaleString(locale, options);
      } catch (error) {
        console.error("Date formatting error:", error);
        return dateObj.toLocaleString("en-US", options);
      }
    },
    isCardOverflowing(cardElem) {
      var curOverflow = cardElem.style.overflow;

      if (!curOverflow || curOverflow === "visible")
        cardElem.style.overflow = "hidden";

      var isOverflowing =
        cardElem.clientWidth < cardElem.scrollWidth ||
        cardElem.clientHeight < cardElem.scrollHeight;

      cardElem.style.overflow = curOverflow;

      return isOverflowing;
    },
  },
  watch: {
    cardWidth() {
      const overflowingBool = this.isCardOverflowing(
        this.$refs["card-inner-wrapper"]
      );
      this.state.overflowing=overflowingBool;
    },
  },
};
</script>

<style scoped>
.tf-carousel-card {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: var(--border-radius-secondary);
}

.show-more-btn {
  box-shadow: white -10px 5px 10px 6px;
  background: white;
  bottom: 1.5rem;
  right: 1.5rem;
}

.excess-text-cover {
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 10px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
}

.card-inner-wrapper {
  max-height: 100%;
}
</style>
